import {useSelector} from "react-redux";

export default function useUserData(props){
    return useSelector((state) => state.user?.data)
}